import { LOCALE_STORAGE_KEY, type AppLocale } from '@/i18n';
import { useI18n } from 'vue-i18n';

export function useLocale() {
  const { locale, t } = useI18n();

  function setLocale(next: AppLocale) {
    locale.value = next;
    localStorage.setItem(LOCALE_STORAGE_KEY, next);
    document.documentElement.lang = next;
    document.title = t('app.title');
  }

  function syncDocument() {
    document.documentElement.lang = locale.value as string;
    document.title = t('app.title');
  }

  function ensureDefaultLocale() {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored === 'es' || stored === 'en') {
      locale.value = stored;
      syncDocument();
      return;
    }
    setLocale('es');
  }

  return { locale, setLocale, syncDocument, ensureDefaultLocale };
}
